"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useEventHandler_1 = require("../utils/useEventHandler");
var NsDatepicker = function (_a) {
    var autocomplete = _a.autocomplete, helper = _a.helper, label = _a.label, max = _a.max, min = _a.min, name = _a.name, type = _a.type, validation = _a.validation, value = _a.value, onChange = _a.onChange, children = _a.children;
    var ref = (0, react_1.useRef)();
    (0, useEventHandler_1.useEventHandler)(ref, 'change', onChange);
    return (react_1.default.createElement("ns-datepicker", { ref: ref, validation: validation, label: label, helper: helper, value: value, min: min, max: max, name: name, type: type, autocomplete: autocomplete }, children));
};
exports.default = NsDatepicker;
